import { useEffect } from 'react';
import { Text, Loader, Stack } from '@hotjar/hotsauce';
import { useGTMCheck } from '../hooks/useGTMCheck';

interface GTMLoaderProps {
  onCheckFinished: (success: boolean) => void;
}

export const GTMLoader = ({ onCheckFinished }: GTMLoaderProps): JSX.Element => {
  const { data: gtmCheckResult } = useGTMCheck();
  const message = gtmCheckResult?.message;

  useEffect(() => {
    if (gtmCheckResult?.finished) {
      onCheckFinished(gtmCheckResult.success);
    }
  }, [gtmCheckResult, onCheckFinished]);

  return (
    <Stack direction="column" style={{ alignItems: 'center', justifyContent: 'center' }}>
      <Loader size="xl" isLoading />
      {message ? <Text>{message}</Text> : null}
    </Stack>
  );
};
